import { BaseService } from '../../infra/base.service'
import type { ServiceCategoriesRepository } from './service-categories.repository'
import type { ServiceCategoryEntity } from './service-category.entity'

export class ServiceCategoriesService extends BaseService<ServiceCategoryEntity> {
    constructor(private rep: ServiceCategoriesRepository) {
        super(rep)
    }
}
